import { isBrowser as u } from "../../libs/platform/util-isomorphic/dist/index.js";
const c = () => u() ? window : null, r = c(), i = "X-Allow-Cookies", O = "X-Block-Cookies", C = "true", E = "X-CSRF-Token", a = "OptanonAlertBoxClosed";
function s() {
  return r.OnetrustActiveGroups;
}
function d() {
  var n, e, o, t;
  return (t = (o = (e = (n = r.OneTrust) == null ? void 0 : n.GetDomainData) == null ? void 0 : e.call(n)) == null ? void 0 : o.ConsentModel) == null ? void 0 : t.Name;
}
function l() {
  const n = !s(), e = /C000[^1]/.test(s()), o = d() === "opt-out", t = document.cookie.includes(a);
  return !!(n || e || o || t);
}
function p() {
  if (!(process.env.NODE_ENV === "production" || process.env.NODE_ENV === "development"))
    return {};
  const n = {
    [O]: C
  }, e = s();
  return l() && e ? {
    ...n,
    [i]: e
  } : n;
}
export {
  a as ONE_TRUST_ALERT_COOKIE,
  i as X_ALLOW_COOKIES,
  O as X_BLOCK_COOKIES,
  C as X_BLOCK_COOKIES_DEFAULT_VALUE,
  E as X_CSRF_Token,
  p as generateEnvoyConsentHeader,
  c as getOneTrustWindow,
  l as hasConsentBeenSet,
  r as onetrustWindow
};
